var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobApplicationIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133,
    height: 81,
    viewBox: "0 0 133 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "job_application_icon1",
    transform: "translate(-1621 -5841)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153070",
    "data-name": "\\uC0AC\\uAC01\\uD615 153070",
    width: 26,
    height: 26,
    transform: "translate(1621 5841)",
    fill: "#c7d4e4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153071",
    "data-name": "\\uC0AC\\uAC01\\uD615 153071",
    transform: "translate(1647 5867)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 26,
    height: 26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153072",
    "data-name": "\\uC0AC\\uAC01\\uD615 153072",
    transform: "translate(1673 5841)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 26,
    height: 26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153074",
    "data-name": "\\uC0AC\\uAC01\\uD615 153074",
    transform: "translate(1647 5893)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 26,
    height: 26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153073",
    "data-name": "\\uC0AC\\uAC01\\uD615 153073",
    transform: "translate(1673 5867)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 26,
    height: 26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153075",
    "data-name": "\\uC0AC\\uAC01\\uD615 153075",
    transform: "translate(1699 5841)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 26,
    height: 26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153076",
    "data-name": "\\uC0AC\\uAC01\\uD615 153076",
    transform: "translate(1673 5893)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 26,
    height: 26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153077",
    "data-name": "\\uC0AC\\uAC01\\uD615 153077",
    transform: "translate(1699 5867)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 26,
    height: 26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153078",
    "data-name": "\\uC0AC\\uAC01\\uD615 153078",
    transform: "translate(1725 5841)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 26,
    height: 26,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobApplicationIcon1);
export default __webpack_public_path__ + "static/media/job_application_icon1.ae9c8087734b8932d299b851a52b2024.svg";
export { ForwardRef as ReactComponent };